import { render, staticRenderFns } from "./listSolicitudes.vue?vue&type=template&id=6a4bb53c&scoped=true"
import script from "./listSolicitudes.vue?vue&type=script&lang=js"
export * from "./listSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./listSolicitudes.vue?vue&type=style&index=0&id=6a4bb53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4bb53c",
  null
  
)

export default component.exports